'use client';

import { useEffect, useState } from 'react';
import type { HomeSettings } from '@/lib/home-v2/schema';

/** Floating WhatsApp chat + back-to-top (sits above the mobile bottom bar). */
export function FloatingActions({ floating, phone }: { floating: HomeSettings['floating']; phone: string }) {
  const [showTop, setShowTop] = useState(false);
  useEffect(() => {
    const onScroll = () => setShowTop(window.scrollY > 1200);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  if (!floating.whatsapp && !floating.backToTop) return null;
  const wa = `https://wa.me/${phone.replace(/\D/g, '')}?text=${encodeURIComponent(floating.whatsappMessage)}`;
  return (
    <div className="fixed bottom-24 right-4 z-40 flex flex-col items-end gap-2.5 lg:bottom-8 lg:right-8">
      {floating.backToTop && showTop && (
        <button type="button" onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })} aria-label={floating.backToTopLabel}
          className="flex h-11 w-11 items-center justify-center rounded-xl border border-hv-line bg-white text-hv-ink shadow-lg transition hover:border-hv-ink">
          <svg className="h-5 w-5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.8} strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><path d="M12 19V5M5 12l7-7 7 7" /></svg>
        </button>
      )}
      {floating.whatsapp && (
        <a href={wa} target="_blank" rel="noopener noreferrer" aria-label={floating.whatsappLabel}
          className="flex h-12 items-center gap-2 rounded-full bg-[#25D366] px-4 font-semibold text-white shadow-lg transition hover:brightness-95">
          <svg className="h-5 w-5" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M12 2a10 10 0 0 0-8.6 15.1L2 22l5-1.3A10 10 0 1 0 12 2zm5.3 14.1c-.2.6-1.3 1.2-1.8 1.2-.5.1-1 .2-3.3-.7-2.8-1.1-4.6-4-4.7-4.2-.1-.2-1.1-1.5-1.1-2.9s.7-2.1 1-2.4c.3-.3.6-.3.8-.3h.6c.2 0 .4 0 .6.5l.9 2.1c.1.2.1.4 0 .6l-.4.6-.4.4c-.1.1-.3.3-.1.6.2.3.8 1.3 1.7 2.1 1.2 1 2.1 1.3 2.4 1.5.3.1.5.1.6-.1l.9-1c.2-.3.4-.2.6-.1l2 1c.3.1.5.2.5.3.1.2.1.7-.1 1.2z" /></svg>
          <span className="hidden text-sm sm:inline">{floating.whatsappLabel}</span>
        </a>
      )}
    </div>
  );
}
